import React from 'react'
import LayoutForm  from '../LayoutForm';
// import FormPosition from '../FormPosition/FormPosition';
import { TriToggle } from '../../../components/TriToggle/TriToggle';
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import classnames from 'classnames';
import { FieldArray, Field } from 'formik';
import ColorSelect from "../../../components/ColorSelect/ColorSelect";
import StyledField from "../../../components/StyledField/StyledField";
import Icon from "../../../components/Icon/Icon";
import Button from '../../../components/Button/Button';
import FormPosition from "../../../components/FormPosition/FormPosition";
import defaultSlide from '../defaultSlide';
import styled from 'styled-components';

const Label = styled.div`
  display: inline-block;
  width: 95%;
`;

const DragIcon = styled(Icon)`
  display: inline-block;
`;

const Sort = styled.div`
  background-color: #f1c788;
  border-radius: 4px;
  padding: 10px;
`;

const SortModal = styled.div`
  background-color: #f9e7cc;
  border-radius: 8px;
  display: ${({ open }) => open ? 'block' : 'none' };
  left: 50px;
  overflow: auto;
  padding: 20px;
  position: absolute;
  top: 150px;
  width: calc(100vw - 100px);
  z-index: 1000;
`;

const RemoveSlide = styled.div`
  float: right;
`;

const SortLink = styled.div`
  display: inline-block;
  color: #ab3029;
  cursor: pointer;
  margin-left: 40px !important;
`;

const SortButton = styled(Button)`
  margin: 20px 0;
  width: 100%;
`

class SlideForm extends React.Component {
  state = {
    selectedSlide: 0,
    showCaption: false,
    open: false
  };

  handleSelectSlide = (index) => this.setState({ selectedSlide: index });
  toggleCaption = () => this.setState({ showCaption: !this.state.showCaption });

  onSort = (data, arrayHelpers) => {
    arrayHelpers.swap(data.oldIndex, data.newIndex)
  };

  render() {
    const { values } = this.props;
    const { selectedSlide } = this.state;
    const deviceToggleOptions = [
      { name: 'Desktop', value: 'desktop' },
      { name: 'both', value : 'both' },
      { name: 'Mobile', value: 'mobile' },
    ];
    const DragHandle = sortableHandle(() => <DragIcon name="drag" label="Drag" inline style={{ cursor: 'pointer' }}/>);

    const SortableContainer = sortableContainer(({children}) => {
      return <div>{children}</div>;
    });

    const SortableItem = sortableElement(({ value, i }) => {
      return (<FieldArray name="slides" render={
        arrayHelpers => (
            <Sort className="margin--top" key={i}>
              <Label>{ value.title }</Label>
              <DragHandle />
            </Sort>)
      } />)
    });


    return (<FieldArray name="slides" render=
                    { arrayHelpers => {
                      return (
                          <section className={ this.props.active ? 'tab-content is-enabled' : 'tab-content' }>
                            <h2>Slides</h2>
                            <SortModal open={ this.state.open }>
                              <SortableContainer onSortEnd={ (data) => this.onSort(data, arrayHelpers) } useDragHandle>
                                <div>
                                  { values && values.slides && values.slides.length > 0 && values.slides.map((value, index) =>
                                      <SortableItem key={`item-${index}`} i={ index } index={index} value={value} />
                                  )}
                                </div>
                              </SortableContainer>
                              <SortButton onClick={ (e) => { e.preventDefault(); this.setState({ open: false }); } }>Done</SortButton>
                            </SortModal>
                            <div>
                              <ul className="tabs">
                                { values && values.slides && values.slides.length > 0 && values.slides.map((slide, index) => {
                                  const classes = ['level1', {'active': index === selectedSlide }];
                                  return (
                                      <li onClick={ () => this.handleSelectSlide(index) } key={ index } className={ classnames(classes) }>
                                        {slide.title}
                                      </li>
                                  )
                                })
                                }
                                <li className="">
                                  <span className="plus-button" onClick={(e) => arrayHelpers.insert(values.slides.length, defaultSlide) }>
                                    <Icon name="add" inline label="Add"/>
                                      Slide
                                  </span>
                                </li>
                              </ul>
                            </div>

                            <div className="margin--bottom">

                              { values && values.slides && values.slides.length > 0 && values.slides.sort((a, b) => (a.slideDisplayOrder > b.slideDisplayOrder) ? 1 : ((b.slideDisplayOrder > a.slideDisplayOrder) ? -1 : 0)).map((slide, index) => {
                                const classes = ['level1', 'tab-content', 'margin--bottom', {'is-enabled': index === selectedSlide }];
                                return (

                                    <div key={ index } className={ classnames(classes) }>
                                      <div className="grid">
                                        <div className="grid-item">
                                          <Field component={ StyledField }
                                                 label="Title"
                                                 name={`slides.${index}.title`}
                                                 hint="Does not appear in slides (used for organization purposes only)"
                                          />
                                          <div className="field-group margin--top-doubled">
                                            <Field component={ StyledField } hint="Set the number of vertical grid lines to use for the slide" inline small label="Cols" name={`slides.${index}.layout.numberOfColumns`}  />
                                            <Field component={ StyledField } hint="Set the number of horizontal grid lines to use for the slide" inline small label="Rows" name={`slides.${index}.layout.numberOfRows`}  />
                                            <Field component={ StyledField } hint="Set gutter in px value, e.g., 20px" inline small label="Gutter" name={`slides.${index}.layout.gridGap`}  />
                                          </div>
                                        </div>
                                        <div className="grid-item">
                                          <div className="field-group--inline">
                                            <Field component={ TriToggle } name={`slides.${index}.layout.device`} values={ values } selectedSlide={ index } options={ deviceToggleOptions } />
                                          </div>
                                          <SortLink className="field-group--inline" onClick={ () => { this.setState({ open: true })}}>Sort slides</SortLink>
                                          {/*<div className="field-group--inline">*/}
                                            {/*<Field component={ StyledField } inline small label="Order" name={`slides.${index}.slideDisplayOrder`}  />*/}
                                          {/*</div>*/}
                                          <RemoveSlide key="remove" className="field-group--inline" style={ { cursor: 'pointer', verticalAlign: '-5px' } }>
                                            <label />
                                            <Icon name="trash" onClick={ (e) => { arrayHelpers.remove(selectedSlide); this.setState({ selectedSlide: 0 }) } } inline /> Remove Slide
                                          </RemoveSlide>
                                        </div>
                                      </div>

                                      {/*<div className="field-group--inline field-group--has-checkbox">*/}
                                      {/*<label>Mobile</label>*/}
                                      {/*<input type='checkbox' data-index={ index } data-section="layout" checked={ slide.layout.mobile || slide.layout.mobile === 'on' } className="tiny" name="mobile" />*/}
                                      {/*</div>*/}

                                      <LayoutForm device={ values.slides[index].layout.device } values={ values } setFieldValue={ this.props.setFieldValue } selectedSlide={ selectedSlide } {...this.props } />
                                      <label onClick={ this.toggleCaption }>Add Caption</label>
                                      <div style={ { display: !this.state.showCaption ? 'none' : 'block' } }>
                                        <div className="field-group">
                                          <label className="label-inline">Caption</label>
                                          <Field placeholder="Title" name={`slides.${index}.layout.caption.title`}/>
                                          <Field component="textarea" name={`slides.${index}.layout.caption.body`} />
                                        </div>
                                        <Field component={ FormPosition } values={ values.slides[index].layout.caption } name={`slides.${ index }.layout.caption.position`} />
                                        <ColorSelect name={`slides.${index}.layout.caption.color`} label="Caption Color" />
                                      </div>
                                    </div>

                                )
                              })
                              }

                            </div>

                          </section>
                      )
                    }
                }
    />)
  }
}

export default SlideForm;



// WEBPACK FOOTER //
// ./src/containers/add/SlideForm/SlideForm.js